import { render, staticRenderFns } from "./WebupList.vue?vue&type=template&id=44f18c4a&scoped=true&"
import script from "./WebupList.vue?vue&type=script&lang=ts&"
export * from "./WebupList.vue?vue&type=script&lang=ts&"
import style0 from "./WebupList.vue?vue&type=style&index=0&id=44f18c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f18c4a",
  null
  
)

export default component.exports